import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { AppState } from 'store/store';
import { useSelector } from 'react-redux';
import { menuServices } from 'api/services';
import { IResMenu } from 'api/services/menus/types';
import handleNotification from 'helpers/handleNotification';
import Confirmation from 'shared/Confirmation/Confirmation';
import CustomModal from 'shared/CustomModal/CustomModal';
import { MainTemplate } from 'shared/MainTemplate/MainTemplate';
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TextField,
} from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import './MenuPage.sass';
import { Link } from 'react-router-dom';

export const MenuPage: React.FC = () => {
	const [menus, setMenus] = useState<IResMenu[]>([]);
	const [name, setName] = useState('');
	const [title, setTitle] = useState('');
	const [menuId, setMenuId] = useState<number | string>('');
	const [hasError, setHasError] = useState(false);
	const [loading, setLoading] = useState(false);
	const confirmation = useRef<any>();
	const modal = useRef<any>();
	const { currentLang } = useSelector((state: AppState) => state.langReducer);
	const { user } = useSelector((state: AppState) => state.userReducer);

	useEffect(() => {
		if (currentLang?.code) getMenus();
	}, [currentLang?.code]);

	const getMenus = async () => {
		const res = await menuServices.getMenus().then((res) => res.data);
		setMenus(res);
	};

	const tempalteHandler = () => {
		modal.current.onShow();
	};

	const updateMenu = async (id: string | number) => {
		if (!id) return;
		setMenuId(id);
		try {
			const res = await menuServices
				.getMenuById(Number(id))
				.then((res) => res.data);
			setName(res.name);
			setTitle(res.title);
		} finally {
			modal.current.onShow();
		}
	};

	const saveMenu = async () => {
		if (!name || !title) {
			setHasError(true);
			handleNotification('Заполните поля');
			return;
		}
		setLoading(true);
		const menuData = {
			name,
			title,
		};
		try {
			menuId
				? await menuServices.updateMenu(menuId, menuData)
				: await menuServices.createMenu(menuData);
			handleNotification('Меню сохранено успешно', 'success');
			modal.current.onHide();
			getMenus();
		} catch (e: any) {
			handleNotification(e?.response.data.message || 'ошибка');
		} finally {
			setHasError(false);
			setLoading(false);
		}
	};

	const clearField = () => {
		setName('');
		setTitle('');
		setMenuId('');
	};

	const deleteMenu = async () => {
		if (!menuId) return;
		await menuServices.deleteMenu(menuId);
		handleNotification('Меню удалено успешно', 'success');
		getMenus();
	};

	return (
		<>
			<MainTemplate title='Меню' handler={tempalteHandler} hideBtnByRole>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Заголовок</TableCell>
							<TableCell>Название</TableCell>
							<TableCell>Дата публикации</TableCell>
							<TableCell className='table-last-item'>Действие</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{menus?.map((i) => (
							<TableRow key={i.id}>
								<TableCell>{i.title}</TableCell>
								<TableCell>{i.name}</TableCell>
								<TableCell>
									{moment(i.createdAt).format('DD.MM.YYYY HH:mm')}
								</TableCell>
								<TableCell className='menus__actions table-last-item'>
									<Link
										to={`/menu/${i.id}`}
										className='table-icon table-icon--black'>
										<ArrowForwardIcon />
									</Link>
									<EditIcon
										onClick={() => updateMenu(i.id)}
										className='table-icon'
									/>
									{user?.role === 'SU' && (
										<DeleteForeverIcon
											onClick={() => {
												setMenuId(i.id);
												confirmation.current.onShow();
											}}
											className='table-icon'
											color='secondary'
										/>
									)}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</MainTemplate>
			<Confirmation
				ref={confirmation}
				text='Вы действительно хотите удалить это меню?'
				submit={deleteMenu}
				title='Удалить меню'
				changeState={clearField}
				load={loading}
			/>
			<CustomModal
				ref={modal}
				submit={saveMenu}
				title='Меню'
				changeState={clearField}
				text='Сохранить'
				load={loading}>
				<TextField
					variant='outlined'
					label='Заголовок'
					className='custom-modal-item'
					value={title}
					autoFocus
					onChange={(e) => setTitle(e.target.value as string)}
					error={!title && hasError}
				/>
				<TextField
					variant='outlined'
					label='Название'
					className='custom-modal-item'
					value={name}
					onChange={(e) => setName(e.target.value as string)}
					error={!name && hasError}
				/>
			</CustomModal>
		</>
	);
};
